import manifest from './manifest.js'
export type { UserConfig } from './manifest.js'
/** @todo these should be in the plugins... */
export {
  userConfigSchema,
  midiPluginSchema,
  chordPlayerPluginSchema,
  chordPluginSchema,
  externalToolSchema,
  defaultHotkeys,
} from './manifest.schemas.js'
export type { ExternalTool } from './manifest.schemas.js'
export { defaultUserConfig } from './manifest.js'
export type { TFeature } from './features.js'
export default manifest
